module.exports = __webpack_public_path__ + "fonts/KaTeX_Main-Regular.818582da.ttf";